var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAllAlign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    fill: "#969696",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Solid"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m192 256.01a23.874 23.874 0 0 1 -7.03 16.98l-72 71.98a24 24 0 0 1 -33.94-33.94l31.03-31.03h-70.06a24 24 0 0 1 0-48h70.05l-31.02-31.03a24 24 0 1 1 33.94-33.94l72 72.01a23.892 23.892 0 0 1 7.03 16.97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496 256a24.032 24.032 0 0 1 -24 24h-70.06l31.03 31.03a24 24 0 1 1 -33.94 33.94l-72-71.99a24 24 0 0 1 0-33.94l72-72.01a24 24 0 0 1 33.94 33.94l-31.02 31.03h70.05a24.032 24.032 0 0 1 24 24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320 80v352a24 24 0 0 1 -48 0v-352a24 24 0 0 1 48 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240 80v352a24 24 0 0 1 -48 0v-352a24 24 0 0 1 48 0z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllAlign);
export default __webpack_public_path__ + "static/media/allAlign.3eed54d808212216c9584af2f0d229bd.svg";
export { ForwardRef as ReactComponent };